var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreeText = function SvgFreeText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.523,
    height: 30.026,
    fill: "#52A1FF",
    rx: 6.262,
    transform: "matrix(.8627 .5057 -.49297 .87004 14.8 2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.523,
    height: 41.426,
    fill: "#52A1FF",
    rx: 6.262,
    transform: "matrix(.8627 .5057 -.49297 .87004 25.438 2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.383,
    height: 40.814,
    fill: "#52A1FF",
    rx: 7.691,
    transform: "matrix(.8627 .5057 -.49297 .87004 35.121 0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.523,
    height: 30.261,
    fill: "#52A1FF",
    rx: 6.262,
    transform: "matrix(.8627 .5057 -.49297 .87004 44.918 10)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.523,
    height: 21.788,
    fill: "#52A1FF",
    rx: 6.262,
    transform: "matrix(.8627 .5057 -.49297 .87004 52.742 16)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.8 15.544q0-.552.24-1.032 1.92.168 2.808.168h8.496q.216.192.384.6-.504.888-.816 2.16l-.12.408q-.48.216-1.176.216.216-.96.216-1.44t-.36-.624H17.64q-.456 3.936-.624 6.12h5.376q.384-.576.576-1.296.168-.072.48-.072l.528.096q-.504 1.584-.744 4.056a1.1 1.1 0 0 1-.48.096l-.408-.072q0-.96-.192-1.608h-5.208a356 356 0 0 0-.384 6.456l1.968.36q0 .552-.24 1.032Q16.296 31 15.48 31q-1.152 0-2.472.144l-.36.024q0-.552.24-1.032.96-.288 1.632-.864.624-5.28 1.08-13.296zm10.784 5.616q0-.552.24-1.032a10 10 0 0 0 2.664-.768q.336 0 .6.312.264.288.264.768l-.408 2.88.24.144q.6-1.368 1.848-2.664 1.272-1.32 2.448-1.32.456 0 .816.192.384.192.528.384l.144.192a9 9 0 0 0-.912 2.352l-.12.408q-.48.216-1.176.216.216-.984.216-1.248 0-.672-.456-.816-.528 0-1.656 1.368a13 13 0 0 0-1.848 2.904q-.312 3.6-.6 5.568a7.7 7.7 0 0 1-2.256.36q.384-1.608.672-3.768t.504-6.432zm17.374 8.4q0 .552-.24 1.032-2.544.648-3.648.648-4.128 0-4.128-4.488 0-1.656.72-3.288a7.17 7.17 0 0 1 2.184-2.808q1.488-1.176 3.36-1.176 1.176 0 1.728.6t.552 1.464q0 4.32-6.768 4.464 0 3.288 1.968 3.552zm-1.152-7.416q0-.792-.672-.984h-2.208q-.792.312-1.368 1.392-.576 1.056-.768 2.4 2.76-.096 3.888-.792 1.128-.72 1.128-2.016M51.71 29.56q0 .552-.24 1.032-2.544.648-3.648.648-4.128 0-4.128-4.488 0-1.656.72-3.288a7.17 7.17 0 0 1 2.184-2.808q1.488-1.176 3.36-1.176 1.176 0 1.728.6t.552 1.464q0 4.32-6.768 4.464 0 3.288 1.968 3.552zm-1.152-7.416q0-.792-.672-.984h-2.208q-.792.312-1.368 1.392-.576 1.056-.768 2.4 2.76-.096 3.888-.792 1.128-.72 1.128-2.016"
  })));
};
export default SvgFreeText;